/**
 * @generated SignedSource<<687c154d9d9087ae5fa64da93ba677c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserHistory$data = {
  readonly activities: {
    readonly nodes: ReadonlyArray<{
      readonly createdAt: Date | null | undefined;
      readonly linkLocation: string | null | undefined;
      readonly object: string;
      readonly rowId: UUID;
      readonly verb: string;
    }>;
  };
  readonly firstName: string;
  readonly lastName: string;
  readonly " $fragmentType": "UserHistory";
};
export type UserHistory$key = {
  readonly " $data"?: UserHistory$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserHistory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserHistory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "CREATED_AT_DESC"
        }
      ],
      "concreteType": "ActivitiesConnection",
      "kind": "LinkedField",
      "name": "activities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Activity",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "verb",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkLocation",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "object",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "activities(orderBy:\"CREATED_AT_DESC\")"
    }
  ],
  "type": "GwtUser",
  "abstractKey": null
};

(node as any).hash = "3480af69a64cf472c8b3a06c341a5a8e";

export default node;
